import { render } from "./TsrPeriods.vue?vue&type=template&id=743aa2a4&scoped=true"
import script from "./TsrPeriods.vue?vue&type=script&lang=js"
export * from "./TsrPeriods.vue?vue&type=script&lang=js"

import "./TsrPeriods.vue?vue&type=style&index=0&id=743aa2a4&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/solution/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-743aa2a4"]])

export default __exports__